import React, { useState, useEffect } from 'react';
import { theme } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/common/Header';
import Sidebar from '../components/common/Sidebar';
import CrmSidebar from '../components/common/CrmSidebar';
import { StyledLayout, MainLayout as StyledMainLayout, StyledContent } from '../styles/common';
import { ThemeProvider } from 'styled-components';

const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { token } = theme.useToken();
  const location = useLocation();

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      }
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  // Check if current route should show sidebar (delivery, warehouse, CRM, cycle-counting, purchases, inventory, and sales routes)
  const showSidebar = location.pathname.startsWith('/delivery') ||
                      location.pathname.startsWith('/tog') ||
                      location.pathname.startsWith('/shipment-batch') ||
                      location.pathname.startsWith('/inbound') ||
                      location.pathname.startsWith('/loading') ||
                      location.pathname.startsWith('/warehouse') ||
                      location.pathname.startsWith('/crm') ||
                      location.pathname.startsWith('/cycle-counting') ||
                      location.pathname.startsWith('/purchases') ||
                      location.pathname.startsWith('/inventory') ||
                      location.pathname.startsWith('/access-control') ||
                      location.pathname.startsWith('/ecommerce') ||
                      location.pathname.startsWith('/sales');

  // Determine which sidebar to show
  const isCrmRoute = location.pathname.startsWith('/crm');

  // Theme values for styled-components
  // On mobile, sidebar is an overlay so content doesn't need padding
  const themeValues = {
    siderWidth: showSidebar ? (isMobile ? 0 : (collapsed ? 80 : 250)) : 0,
    primaryColor: token.colorPrimary,
    isMobile,
  };

  return (
    <ThemeProvider theme={themeValues}>
      <StyledLayout>
        {showSidebar && (
          isCrmRoute ? (
            <CrmSidebar collapsed={collapsed} onCollapse={setCollapsed} isMobile={isMobile} />
          ) : (
            <Sidebar collapsed={collapsed} onCollapse={setCollapsed} isMobile={isMobile} />
          )
        )}
        {/* Mobile overlay backdrop */}
        {showSidebar && isMobile && !collapsed && (
          <div
            onClick={() => setCollapsed(true)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.45)',
              zIndex: 1000,
            }}
          />
        )}
        <StyledMainLayout>
          <Header collapsed={collapsed} onToggle={toggleSidebar} isMobile={isMobile} />
          <StyledContent>
            <Outlet />
          </StyledContent>
        </StyledMainLayout>
      </StyledLayout>
    </ThemeProvider>
  );
};

export default MainLayout;
